// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmployeeNameDto
 */
export interface IEmployeeNameDto {
    /**
     * 
     * @type {number}
     * @memberof IEmployeeNameDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeNameDto
     */
    full_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeNameDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeNameDto
     */
    last_name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IEmployeeNameDto
     */
    is_bad_record?: boolean;
}

/**
 * Check if a given object implements the IEmployeeNameDto interface.
 */
export function instanceOfIEmployeeNameDto(value: object): value is IEmployeeNameDto {
    return true;
}

export function IEmployeeNameDtoFromJSON(json: any): IEmployeeNameDto {
    return IEmployeeNameDtoFromJSONTyped(json, false);
}

export function IEmployeeNameDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeNameDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'full_name': json['full_name'] == null ? undefined : json['full_name'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'is_bad_record': json['is_bad_record'] == null ? undefined : json['is_bad_record'],
    };
}

export function IEmployeeNameDtoToJSON(json: any): IEmployeeNameDto {
    return IEmployeeNameDtoToJSONTyped(json, false);
}

export function IEmployeeNameDtoToJSONTyped(value?: IEmployeeNameDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'full_name': value['full_name'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'is_bad_record': value['is_bad_record'],
    };
}

